export const DATE_FORMAT_KEYS = {
    default: 'default',
    defaultExtended: 'defaultExtended',
    defaultExtendedSeconds: 'defaultExtendedSeconds',
    detailed: 'detailed',
    dob: 'dob',
    date: 'date',
    dateTime: 'dateTime',
    isoDate: 'isoDate',
    isoDateTime: 'isoDateTime',
    dateTimeSegmented: 'dateTimeSegmented',
    filter: 'filter',
    time: 'time',
    timeOfDay: 'timeOfDay',
    timeOfDayPeriod: 'timeOfDayPeriod',
    hour: 'hour',
    hourPeriod: 'hourPeriod',
    day: 'day',
    dayShort: 'dayShort',
    month: 'month',
    monthShort: 'monthShort',
};
export const DATE_FORMAT = {
    default: 'DD/MM/YY HH:mm',
    defaultExtended: 'DD/MM/YYYY HH:mm',
    defaultExtendedSeconds: 'DD/MM/YYYY HH:mm:ss',
    detailed: 'MMMM Do YYYY, h:mm:ss a',
    dob: 'DD/MM/YYYY',
    date: 'YYYY-MM-DD',
    dateTime: 'YYYY-MM-DD HH:mm',
    isoDate: 'DD-MM-YYYY',
    isoDateTime: 'DD-MM-YYYY HH:mm',
    dateTimeSegmented: 'YYYY-MM-DD HH mm',
    filter: 'YYYY-MM-DD HH:mm:ss',
    time: 'HH:mm:ss',
    timeOfDay: 'HH:mm',
    timeOfDayPeriod: 'h:mm a',
    hour: 'HH',
    hourPeriod: 'h a',
    day: 'dddd',
    dayShort: 'ddd',
    month: 'MMMM',
    monthShort: 'MMM', // Jan
};
export const DATE_REGEXP = {
    default: /^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d{2}\s([0-1]?[0-9]|2?[0-3]):([0-5]\d)/,
    defaultExtended: /^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d{4}\s([0-1]?[0-9]|2?[0-3]):([0-5]\d)/,
    defaultExtendedSeconds: /^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d{4}\s([0-1]?[0-9]|2?[0-3]):([0-5]\d):([0-5]\d)/,
    dob: /^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d{4}/,
    date: /^\d{4}-([0]{0,1}[1-9]|1[012])-([1-9]|([012][0-9])|(3[01]))/,
    dateTime: /^\d{4}-([0]{0,1}[1-9]|1[012])-([1-9]|([012][0-9])|(3[01]))\s([0-1]?[0-9]|2?[0-3]):([0-5]\d)/,
    isoDate: /^([1-9]|([012][0-9])|(3[01]))-([0]{0,1}[1-9]|1[012])-\d{4}/,
    isoDateTime: /^([1-9]|([012][0-9])|(3[01]))-([0]{0,1}[1-9]|1[012])-\d{4}\s([0-1]?[0-9]|2?[0-3]):([0-5]\d)/,
    dateTimeSegmented: /^\d{4}-([0]{0,1}[1-9]|1[012])-([1-9]|([012][0-9])|(3[01]))\s([0-1]?[0-9]|2?[0-3])\s([0-5]\d)/,
    filter: /^\d{4}-([0]{0,1}[1-9]|1[012])-([1-9]|([012][0-9])|(3[01]))\s([0-1]?[0-9]|2?[0-3]):([0-5]\d):([0-5]\d)/,
    time: /^([0-1]?[0-9]|2?[0-3]):([0-5]\d):([0-5]\d)/,
    timeOfDay: /^([0-1]?[0-9]|2?[0-3]):([0-5]\d)/,
    timeOfDayPeriod: /^([1-9]|1[0-2]):([0-5]\d)\s([ap]m)/, // 9:00 pm
};
export const TIME_ZONE = {
    default: 'Europe/Madrid',
    amsterdam: 'Europe/Amsterdam',
    andorra: 'Europe/Andorra',
    astrakhan: 'Europe/Astrakhan',
    athens: 'Europe/Athens',
    belfast: 'Europe/Belfast',
    belgrade: 'Europe/Belgrade',
    berlin: 'Europe/Berlin',
    bratislava: 'Europe/Bratislava',
    brussels: 'Europe/Brussels',
    bucharest: 'Europe/Bucharest',
    budapest: 'Europe/Budapest',
    busingen: 'Europe/Busingen',
    chisinau: 'Europe/Chisinau',
    copenhagen: 'Europe/Copenhagen',
    dublin: 'Europe/Dublin',
    gibraltar: 'Europe/Gibraltar',
    guernsey: 'Europe/Guernsey',
    helsinki: 'Europe/Helsinki',
    isle_of_man: 'Europe/Isle_of_Man',
    istanbul: 'Europe/Istanbul',
    jersey: 'Europe/Jersey',
    kaliningrad: 'Europe/Kaliningrad',
    kiev: 'Europe/Kiev',
    kirov: 'Europe/Kirov',
    lisbon: 'Europe/Lisbon',
    ljubljana: 'Europe/Ljubljana',
    london: 'Europe/London',
    luxembourg: 'Europe/Luxembourg',
    madrid: 'Europe/Madrid',
    malta: 'Europe/Malta',
    mariehamn: 'Europe/Mariehamn',
    minsk: 'Europe/Minsk',
    monaco: 'Europe/Monaco',
    moscow: 'Europe/Moscow',
    nicosia: 'Europe/Nicosia',
    oslo: 'Europe/Oslo',
    paris: 'Europe/Paris',
    podgorica: 'Europe/Podgorica',
    prague: 'Europe/Prague',
    riga: 'Europe/Riga',
    rome: 'Europe/Rome',
    samara: 'Europe/Samara',
    san_Marino: 'Europe/San_Marino',
    sarajevo: 'Europe/Sarajevo',
    saratov: 'Europe/Saratov',
    simferopol: 'Europe/Simferopol',
    skopje: 'Europe/Skopje',
    sofia: 'Europe/Sofia',
    stockholm: 'Europe/Stockholm',
    tallinn: 'Europe/Tallinn',
    tirane: 'Europe/Tirane',
    tiraspol: 'Europe/Tiraspol',
    ulyanovsk: 'Europe/Ulyanovsk',
    uzhgorod: 'Europe/Uzhgorod',
    vaduz: 'Europe/Vaduz',
    vatican: 'Europe/Vatican',
    vienna: 'Europe/Vienna',
    vilnius: 'Europe/Vilnius',
    volgograd: 'Europe/Volgograd',
    warsaw: 'Europe/Warsaw',
    zagreb: 'Europe/Zagreb',
    zaporozhye: 'Europe/Zaporozhye',
    zurich: 'Europe/Zurich',
};
